import React, { Component } from "react";
import { Button, Col, DatePicker, Form, Select, Modal,notification } from "antd";
import connect from "react-redux/es/connect/connect";
import { injectIntl } from "react-intl-context";
import {
    createRandDataConfig,
    getPelLeagueDictionaries,
    getPelTeamRankIntegral,
    getRankBaseDataConfig,
    getRankDataConfig,
    getRankDataConfigBrands,
    deleteRankDataConfig,
    updateRandDataConfig
} from "../../../modules/training/action";
import moment, { now } from "moment";
import RankDataConfigModel from "./RankDataConfigModel";
import { operationTypeValue } from "../../../modules/training/enums";

const { confirm } = Modal;
const FormItem = Form.Item;
const Option = Select.Option;

const { WeekPicker } = DatePicker;

class TrainingDataIntegralFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            yqlBrandType: null,
            cycle: null,
            isShowRankDataConfigModel: false,
            operationType: null,
        };
    }

    componentWillMount() {
        const { yqlBrandType, getRankDataConfigBrands } = this.props;
        console.log(yqlBrandType);
        getRankDataConfigBrands()
            .then((data) => {
                const startDate = moment(now()).day(1).format("YYYYMMDD"); // 周一日期
                const endDate = moment(now()).day(7).format("YYYYMMDD"); // 周日日期
                this.setState({
                    cycle: `${startDate}-${endDate}`,
                    yqlBrandType: data[0].id,
                });
            })
            .catch((error) => { });
    }

    onChangeWeek = (weekData, dateString) => {
        // console.log(weekData, dateString);
        // const startDate = moment(weekData).day(1).format('YYYY/MM/DD (dddd)'); // 周一日期
        // const endDate = moment(weekData).day(7).format('YYYY/MM/DD (dddd)'); // 周日日期
        const startDate = moment(weekData).day(1).format("YYYYMMDD"); // 周一日期
        const endDate = moment(weekData).day(7).format("YYYYMMDD"); // 周日日期
        let cycle = `${startDate}-${endDate}`;
        this.setState({
            cycle: cycle,
        });
        let { onCommit } = this.props;
        onCommit && onCommit(cycle, this.state.yqlBrandType);
    };

    onChangeBrandType = (e) => {
        console.log(e);
        this.setState({
            yqlBrandType: e,
        });
        let { onCommit } = this.props;
        onCommit && onCommit(this.state.cycle, e);
    };

    onGetRankDataConfigEvent = async (type) => {
        const { isShowRankDataConfigModel, yqlBrandType } = this.state;
        const {
            getRankBaseDataConfig,
            getRankDataConfig,
            rankDataConfigBrands,
        } = this.props;
        let currentBrand =
            rankDataConfigBrands.find((item) => item.id == yqlBrandType) || {};
        if (type === operationTypeValue.INCREASE) {
            await getRankBaseDataConfig();
        } else {
            if (!currentBrand.id) {
                return notification.error({
                    message: '提示',
                    description:
                        '请选中一条榜单',
                });
            }
            await getRankDataConfig(currentBrand && currentBrand.id);
        }
        await this.setState({
            operationType: type,
            isShowRankDataConfigModel: !isShowRankDataConfigModel,
        });
    };
    onFormSubmit = async (params) => {
        const {
            isShowRankDataConfigModel,
            operationType,
            yqlBrandType,
        } = this.state;
        const {
            createRandDataConfig,
            rankDataConfig,
            getRankDataConfigBrands,
            updateRandDataConfig,
        } = this.props;
        console.log(rankDataConfig);
        if (operationType === operationTypeValue.UPDATE) {
            params.id = rankDataConfig.id;
        }
        params.userExhibitionIds = params.userExhibitionIds ? params.userExhibitionIds.split(",") : [];
        params.cycleType = params.cycleType.join(',')
        if(operationType === operationTypeValue.UPDATE){
            await updateRandDataConfig(params);
        }else{
            await createRandDataConfig(params);
        }
        
        getRankDataConfigBrands()
            .then((data) => {
                const startDate = moment(now()).day(1).format("YYYYMMDD"); // 周一日期
                const endDate = moment(now()).day(7).format("YYYYMMDD"); // 周日日期
                this.setState({
                    cycle: `${startDate}-${endDate}`,
                    yqlBrandType: data[0].id,
                });
            })
            .catch((error) => { });

        await this.setState({
            isShowRankDataConfigModel: !isShowRankDataConfigModel,
        });
    };
    onDelete = async (id) => {
        const { isShowRankDataConfigModel, yqlBrandType } = this.state;
        const {
            rankDataConfigBrands,
            deleteRankDataConfig,
            getRankDataConfigBrands
        } = this.props;
        confirm({
            content: '确认要删除这条榜单记录?',
            okText: '确认',
            okType: 'danger',
            cancelText: '取消',
            onOk: async () => {
                await deleteRankDataConfig(id);
                const { resetFields } = this.props.form;
                await getRankDataConfigBrands();
                resetFields && resetFields()
                await this.setState({
                    operationType: operationTypeValue.DELETE,
                    isShowRankDataConfigModel: !isShowRankDataConfigModel,
                });
            },
            onCancel() {
            },

        });

    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { cycle, isShowRankDataConfigModel, operationType } = this.state;
        const { rankDataConfigBrands, getRankDataConfig } = this.props;
        console.log("rankDataConfigBrands",rankDataConfigBrands);
        return (
            <div>
                <Col span={20}>
                    <Form onSubmit={this.handleSubmit} layout="inline">
                        <FormItem label="赛事阶段">
                            {getFieldDecorator("year", {
                                initialValue: moment(),
                            })(
                                <div>
                                    <WeekPicker
                                        defaultValue={moment()}
                                        onChange={this.onChangeWeek}
                                    />
                                    <span>{cycle}</span>
                                </div>
                            )}
                        </FormItem>
                        <FormItem label="训练赛类型">
                            {getFieldDecorator("yqlBrandType", {
                                initialValue: rankDataConfigBrands && rankDataConfigBrands.length > 0
                                    ? rankDataConfigBrands[0]["id"]
                                    : "",
                            })(
                                <Select
                                    style={{ width: "100px" }}
                                    onChange={this.onChangeBrandType}
                                >
                                    {rankDataConfigBrands &&
                                        rankDataConfigBrands.map((item) => {
                                            return <Option value={item.id}>{item.name}</Option>;
                                        })}
                                </Select>
                            )}
                        </FormItem>
                        {/*<FormItem>*/}
                        {/*    <Button type="primary" htmlType="submit" style={{width: '100%'}}>*/}
                        {/*        查询*/}
                        {/*    </Button>*/}
                        {/*</FormItem>*/}
                    </Form>
                </Col>
                <Col span={4}>
                    <span>配置数据榜：</span>
                    <Button
                        type="primary"
                        style={{ marginRight: "10px" }}
                        onClick={() =>
                            this.onGetRankDataConfigEvent(operationTypeValue.INCREASE)
                        }
                    >
                        新增
          </Button>
                    <Button
                        type="primary"
                        style={{}}
                        onClick={() =>
                            this.onGetRankDataConfigEvent(operationTypeValue.UPDATE)
                        }
                    >
                        编辑
          </Button>
                </Col>
                {isShowRankDataConfigModel ? (
                    <RankDataConfigModel
                        operationType={operationType}
                        onSuccess={this.onFormSubmit}
                        onDelete={this.onDelete}
                        visible={isShowRankDataConfigModel}
                        onClose={() => {
                            this.setState({
                                isShowRankDataConfigModel: false,
                            });
                        }}
                    />
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.viewTraining,
    };
};
const mapDispatchToProps = {
    getPelLeagueDictionaries,
    getPelTeamRankIntegral,
    getRankBaseDataConfig,
    createRandDataConfig,
    updateRandDataConfig,
    getRankDataConfig,
    deleteRankDataConfig,
    getRankDataConfigBrands,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(Form.create()(TrainingDataIntegralFilter)));
